<template>
  <div class="countdown">
    {{ days }}天{{ hours.toString().padStart(2, "0") }}小时
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    // 目标日期字符串，格式：'YYYY-MM-DD'
    endDate: {
      type: String,
      required: true,
      validator(value) {
        // 验证格式：2026-04-08 15:30:45
        return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value);
      }
    }
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      timer: null
    };
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startCountdown() {
      // 直接解析 'YYYY-MM-DD HH:mm:ss' 为 Date 对象
      const targetDate = new Date(this.endDate.replace(" ", "T")); // 兼容 Safari

      if (isNaN(targetDate.getTime())) {
        console.error(
          "Invalid endDate format. Expected: 'YYYY-MM-DD HH:mm:ss'"
        );
        return;
      }

      const updateCountdown = () => {
        const now = new Date();
        const diff = targetDate - now;

        if (diff <= 0) {
          this.days = 0;
          this.hours = 0;
          this.minutes = 0;
          this.seconds = 0;
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
          this.$emit("finish");
          return;
        }

        // 计算各时间单位
        const totalSeconds = Math.floor(diff / 1000);
        this.days = Math.floor(totalSeconds / (3600 * 24));
        const remainingAfterDays = totalSeconds % (3600 * 24);
        this.hours = Math.floor(remainingAfterDays / 3600);
        const remainingAfterHours = remainingAfterDays % 3600;
        this.minutes = Math.floor(remainingAfterHours / 60);
        this.seconds = remainingAfterHours % 60;
      };

      updateCountdown(); // 立即执行一次
      this.timer = setInterval(updateCountdown, 1000);
    }
  }
};
</script>

<style scoped>
.countdown {
  font-size: 12px;
  color: #fff9db;
}
</style>



// WEBPACK FOOTER //
// src/components/countdown.vue